import React from "react"
import styled from "styled-components"
import { up, down } from "styled-breakpoints"
import { Link } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"

import Carousel from "../../atomic/molecules/Carousel"
import ArticleCard from "../../atomic/organisms/ArticleCard"

import { H1 } from "../../atomic/atoms/type/H1"
import { H2 } from "../../atomic/atoms/type/H2"
import ArticleTextField from "../../atomic/molecules/ArticleTextField"
import { TYPE } from "../../../theme/styles/globals"

export default class ContentfulModuleArticle extends React.Component {
  state = { 
    active: 0
  };

  componentDidMount(){
    if (typeof window !== `undefined`) {
        document.addEventListener('scroll', () => this.handleScroll())
    }
  }
  componentWillUnmount(){
    if (typeof window !== `undefined`) {
        document.removeEventListener('scroll', () => this.handleScroll())
    }
  }

  calcFacts = () => {
    const { article } = this.props
    const { facts } = article
    //console.log(facts.length)
    switch (facts.length) {
      case 1:
        return "A hot fact"
        break
        case 2:
        return "Two hot facts"
        break
        case 3:
        return "Three hot facts"
        break
    }
  }

  handleScroll = event => {
    const { pageYOffset } = window;
    const { active } = this.state;
    const { article } = this.props
    const { images } = article
    let limit = Math.max( document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight ) - window.innerHeight;
    let zone = Math.ceil(pageYOffset/(limit/images.length)) - 1

    if (zone === -1) { // if pageYOffset is equal to 0 i.e. scrolled back to the top
      this.setState({ active: 0 })
    } else if (zone >= images.length) { // if pageYOffset is equal to or greater than page height i.e. scrolled to the bottom
      this.setState({ active: images.length - 1 })
    } else {
      this.setState({ active: zone });
    }
  };

  render() {
    const { mode, article, transition } = this.props
    const { title, slug, short, thumbnail, images, body, date, tags, tools, facts, related } = article
    const { active } = this.state;
    //console.log(this.props)

    return (
      <Container>
        <Gallery>
          <Short>{short}</Short>
          <GalleryItems>
            {images.map((image, i) => (
              <Image key={i} fluid={image.fluid} style={{opacity: active === i ? "0.4" : "0"}}/>
            ))}
          </GalleryItems>
        </Gallery>
        <Article>
          <Header>
              <Link to="/">
                <Back>BACK TO SLIK</Back>
              </Link>
              <Title>{title}</Title>
              <Date>{date.substring(0,10)}</Date>
              <Tags>
                <TagIcon src="https://images.ctfassets.net/zysgo1161a3j/os9r3aAPQLNtFXx2qm2Qs/e263736f95fda1eb363bfd1aadb53a9e/tag-icon.svg"/>
                {tags.map((tag, i) => (
                  <Tag key={i}>{tag}</Tag>
                ))}
              </Tags>
              <ShareIcon src="https://images.ctfassets.net/zysgo1161a3j/39Mf1UwUhtTug6brEMMnkm/59200e4f7a4130cf4a3cdc0ad252d390/share-icon.svg"/>
          </Header>
          <Body>
            <ArticleTextField json={body.json} />
          </Body>
          { tools && (
          <Tools>
            <ToolsCopy>Tools Used:</ToolsCopy>
            <ToolGroup>
              {tools.map((tool, i) => (
                <ToolImage key={i} fluid={tool.fluid} objectFit="cover" objectPosition="50% 50%"/>
              ))}
            </ToolGroup>            
          </Tools>
          )}
          { facts && (
          <Facts>
            <FactsCopy>{this.calcFacts()} <span role="img">&#128293;</span></FactsCopy>
              {facts.map((fact, i) => (
                <FactGroup key={i}>
                  <FactNumber>{`0${i+1}`}</FactNumber>
                  <Fact>{fact}</Fact>
                </FactGroup>
              ))}
          </Facts>
          )}
          <RelatedHeading>Keep reading?</RelatedHeading>
          <RelatedContainer>
            <CarouselWrap>
              <Carousel
                id={"article-list"}
                mode="LIGHT"
                slidesPerView={1.1}
                centeredSlides={true}
                spaceBetween={10}
              >
                {related.map((relatedArticle, i) => (
                  <ArticleCard
                    key={i}
                    title={relatedArticle.title}
                    short={relatedArticle.short}
                    slug={relatedArticle.slug}
                    image={relatedArticle.thumbnail}
                    transition={transition}
                    stacked="vertical"
                  />
                ))}
              </Carousel>
            </CarouselWrap>
            <RelatedArticles>
              {related.map((relatedArticle, i) => (
                  <ArticleCard
                    key={i}
                    title={relatedArticle.title}
                    short={relatedArticle.short}
                    image={relatedArticle.thumbnail}
                    slug={relatedArticle.slug}
                    transition={transition}
                    stacked="grid"
                  />
              ))}
            </RelatedArticles>
          </RelatedContainer>
        </Article>
      </Container>
    )
  }
}

const Container = styled.section`
  width: 100%;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: column;

  ${up("md")} {
    flex-direction: row;
    justify-content: flex-end;
  }
`

const Gallery = styled.div`
  width: 100%;
  height: 60vh;
  background: black;
  overflow: hidden;
  position: relative;

  ${up("md")} {
    width: 45%;
    height: 100vh;
    position: fixed;
    top: 0px;
    left: 0px;
  }
`

const Tools = styled.div`
  width: 100%;
  margin-bottom: 60px;
`
const ToolsCopy = styled.p`
  font-family:${TYPE.MONO_FONT};
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #191616;
  font-size: 10px;
  line-height: 10px;
`

const ToolGroup = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-evenly;
  ${up("lg")} {
    flex-wrap: nowrap;
  }
`

const ToolImage = styled(Img)`
  margin-top: 20px;
  width: 40%;
  
`

const Facts = styled.div`
  width: 100%;
  margin-bottom: 60px;
`

const FactsCopy = styled(ToolsCopy)`
`

const FactGroup = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: 24px;
  ${up("custom")} {
    align-items: center;
  }
`

const FactNumber = styled.div`
  font-family: ${TYPE.SERIF_BOLD_FONT};
  color: #181616;
  opacity: 0.13;
  font-size: 64px;
  line-height: 0.94em;
  height: 0.84em;
  margin-right: 20px;
  ${up("custom")} {
    font-size: 80px;
    margin-right: 30px;
  }
`

const Fact = styled.p`
  font-family: ${TYPE.SERIF_FONT};
  color: #000;
  font-size: 16px;
  line-height: 25px;
`

const Article = styled.div`
  padding: 20px;
  ${up("md")} {
    width: 55%;
    padding: 60px 6%;
    position: relative;
  }
`
const Header = styled.div`
  position:relative;
  margin-bottom:60px;
`

const Title = styled(H2)`
  ${down("xs")}{
    font-size:32px;
    line-height:32px;
  }
  ${up("md")}{
    font-size:54px;
    line-height:54px;
    margin-bottom:30px;
    margin-top:30px;
  }
`

const Body = styled.div`
  border-top: 1px solid black;
  padding-top: 60px;
`

const GalleryItems = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
`

const Image = styled(Img)`
  width: 100%;
  height: 100%;
  opacity: 0.4;
  position: absolute !important;
  top: 0;
  left: 0;
  transition: opacity 0.3s ease-in-out;
`

const Short = styled(H2)`
  position: absolute;
  left: 10%;
  bottom: 10%;
  z-index: 2;
  color: white;
  width: 80%;
`

const Back = styled.span`
  font-family:${TYPE.MONO_FONT};
  text-transform: uppercase;
  letter-spacing: 0.2em;
  text-decoration: none;
  color: #191616;
  font-size: 10px;
  line-height: 10px;
  display: block;
  margin: 11px 0 20px 0;
`

const Date = styled.p`
  position:absolute;
  font-family:${TYPE.MONO_FONT};
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #191616;
  font-size: 10px;
  line-height: 10px;
  bottom: -37px;
  ${up("md")}{
    bottom:auto;
  }
`

const Tags = styled.div`
  display:flex;
  position:absolute;
  ${up("md")}{
    left:auto;
    bottom:auto;
    right:60px;
  }
  bottom:-94px;
`

const TagIcon = styled.img`
  width:12px;
  height:12px;
`

const ShareIcon = styled.img`
  position:absolute;
  right:0;
  width:12px;
  height:12px;
  cursor: pointer;
  ${up("md")}{
    left:auto;
    bottom:auto;
  }
  bottom:-94px;
`

const Tag = styled.span`
  font-family:${TYPE.MONO_FONT};
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #191616;
  font-size: 10px;
  line-height: 10px;
  margin-left: 10px;
`

const RelatedContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  ${up("md")} {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`

const RelatedArticles = styled.div`
  display: none;

  ${up("md")} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2vh 2vh;
    grid-template-areas:
      ". ."
      ". .";
  }
  a:nth-child(3),
  a:nth-child(4){
    transform: translateX(6vh);
  }

`

const CarouselWrap = styled.div`
  display: block;
  padding-top: 30px;
  ${up("md")} {
    display: none;
  }
`
const RelatedHeading = styled(ToolsCopy)`
  margin-bottom:30px;
`

// export const ArticleQuery = graphql`
// query ArticleQuery($contentful_id: String!){
//   contentfulPage(contentful_id: { eq: $contentful_id }){
//     modules {
//       ... on ContentfulModuleArticle {
//         article {
//           title
//           slug
//           short
//           thumbnail {
//             fluid(maxWidth: 1200, quality: 100) {
//               ...GatsbyContentfulFluid_withWebp
//             }
//           }
//           images {
//             fluid(maxWidth: 1200, quality: 100) {
//               ...GatsbyContentfulFluid_withWebp
//             }
//           }
//           body {
//             json
//           }
//           date
//         }
//       }
//     }
//   }
// }
// `